import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { PackageVersionDTO } from 'src/app/model/package-version-dto';
import { UpdatesService } from 'src/app/services/updates.service';

@Component({
  selector: 'app-update-manager',
  templateUrl: './update-manager.component.html',
  styleUrl: './update-manager.component.scss'
})
export class UpdateManagerComponent implements OnInit {
  public appPackagesFrontend: PackageVersionDTO[] = []
  public appPackagesBackend: PackageVersionDTO[] = []
  public readonly tabAll: string = 'all'
  public readonly tabFrontend: string = 'frontend'
  public readonly tabBackend: string = 'backend'
  public currentTab: string = this.tabAll
  public workingFrontend: boolean = false
  public workingBackend: boolean = false

  constructor(private readonly updatesService: UpdatesService){
    AppComponent.updateAppHeader('update manager')
  }

  ngOnInit(): void {
    this.checkUpdates()
  }

  showFrontendTab(): boolean {
    return this.currentTab === this.tabFrontend ||
    this.currentTab === this.tabAll
  }

  showBackendTab(): boolean {
    return this.currentTab === this.tabBackend ||
    this.currentTab === this.tabAll
  }

  public updateAvailable(appPackage: PackageVersionDTO){
    return appPackage.current !== appPackage.latest
  }

  public checkUpdates(): void {
    this.appPackagesFrontend = []
    this.appPackagesBackend = []

    this.workingFrontend = true
    this.workingBackend = true

    this.updatesService.getUpdatesFrontend().subscribe(data => {
      this.appPackagesFrontend = Object.keys(data).map(key => ({
        name: data[key].name,
        current: data[key].current,
        latest: data[key].latest,
        project: data[key].project
      }))
      this.sortPackagesFrontend()
      this.workingFrontend = false
    })

    this.updatesService.getUpdatesBackend()
    .then(response => {
      this.appPackagesBackend = response;
      this.sortPackagesBackend()
      this.workingBackend = false
    })
  }


  sortPackagesFrontend(): void {
    this.appPackagesFrontend.sort((a, b) => {
      if (a.current !== a.latest && b.current === b.latest) {
        return -1;
      }
      if (a.current === a.latest && b.current !== b.latest) {
        return 1;
      }
      return 0;
    })
  }

  sortPackagesBackend(): void {
    const groupedPackages: { [key: string]: PackageVersionDTO[] } = this.appPackagesBackend.reduce((acc, pkg) => {
      const projectName = pkg.project!;
      if (!acc[projectName]) {
        acc[projectName] = []
      }
      acc[projectName].push(pkg)
      return acc
    }, {} as { [key: string]: PackageVersionDTO[] })

    this.appPackagesBackend = Object.keys(groupedPackages).flatMap(project => {
      return groupedPackages[project].sort((a, b) => {
        if (a.current !== a.latest && b.current === b.latest) {
          return -1
        }
        if (a.current === a.latest && b.current !== b.latest) {
          return 1
        }
        return 0
      })
    })
  }
}
